<!-- eslint-disable @angular-eslint/template/mouse-events-have-key-events -->
<div class="de-toolbar" (mouseover)="mouseOver()" (mouseout)="mouseOut()">
  <q9-toolbar>
    <div q9-right-content>
      <div class="toolbar-content-container">
        <q9-icon-button
          class="sb-toolbar-actions"
          q9Track="TOOLBAR.ZOOM_TO_FIT"
          matTooltip="{{ 'TOOLBAR.ZOOM_FIT' | translate }}"
          matTooltipPosition="above"
          [hidden]="!showBtn"
          [icon]="'fit_to_screen-icon'"
          [disabled]="canvasIsEmpty"
          (click)="fit()"></q9-icon-button>
        <q9-icon-button
          class="sb-toolbar-actions"
          q9Track="TOOLBAR.ZOOM_IN"
          matTooltip="{{ 'TOOLBAR.ZOOM_IN' | translate }}"
          matTooltipPosition="above"
          [icon]="'zoom_in-icon'"
          (click)="zoomIn()"></q9-icon-button>
        <q9-icon-button
          class="sb-toolbar-actions"
          q9Track="TOOLBAR.ZOOM_OUT"
          matTooltip="{{ 'TOOLBAR.ZOOM_OUT' | translate }}"
          matTooltipPosition="above"
          [icon]="'zoom_out-icon'"
          (click)="zoomOut()"></q9-icon-button>
        <q9-icon-button
          *ngIf="showFullScreen"
          class="sb-toolbar-actions"
          matTooltipPosition="above"
          [icon]="isFullScreen ? 'exit_full_screen' : 'full_screen-icon'"
          [q9Track]="
            isFullScreen ? 'TOOLBAR.EXIT_FULL_SCREEN_MODE' : 'TOOLBAR.ENTER_FULL_SCREEN_MODE'
          "
          [matTooltip]="
            (isFullScreen ? 'TOOLBAR.FULL_SCREEN_MODE_EXIT' : 'TOOLBAR.FULL_SCREEN_MODE_ENTER')
              | translate
          "
          (click)="fullScreen()"></q9-icon-button>
      </div>
    </div>
  </q9-toolbar>
</div>
